import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosConfig';
import InputField from 'components/fields/InputField';
import FixedPlugin from 'components/fixedPlugin/FixedPlugin';
import Footer from 'components/footer/FooterAuthDefault';
import { Link, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import routes from 'routes.js';
import moment from 'moment-timezone';
// import authImg from 'assets/img/auth/auth.png'; // Commented out

const Auth = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [user_timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
  const [botBadgeId, setBotBadgeId] = useState('');
  const [rememberMe] = useState(false);
  const [error, setError] = useState('');
  const [timezones, setTimezones] = useState([]);
  const navigate = useNavigate();

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/auth') {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      }
      return null;
    });
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      const response = await axiosInstance.post('/signup', {
        name: username,
        email,
        password,
        bot_badge_id: botBadgeId,
        timezone: user_timezone,
      });

      const { access_token } = response.data;

      if (rememberMe) {
        localStorage.setItem('access_token', access_token);
      } else {
        sessionStorage.setItem('access_token', access_token);
      }

      navigate('/admin/default');
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message || 'Failed to register.');
      } else if (err.request) {
        setError('Network error: No response from server.');
      } else {
        setError(err.message || 'Unexpected error occurred.');
      }
    }
  };

  useEffect(() => {
    document.documentElement.dir = 'create-user';
    setTimezones(moment.tz.names());
  }, []);

  return (
    <div className="relative h-full min-h-screen w-full bg-white dark:bg-navy-900">
      <FixedPlugin />
      <main className="flex items-center justify-center min-h-screen px-4">
        <div className="w-full max-w-2xl bg-white dark:bg-navy-800 shadow-lg rounded-xl p-8 md:p-12">
          <Routes>
            {getRoutes(routes)}
            <Route path="/" element={<Navigate to="/auth/register" replace />} />
          </Routes>

          <h4 className="mb-4 text-4xl font-bold text-center text-navy-700 dark:text-white">
            Sign Up
          </h4>
          <p className="mb-6 text-center text-base text-gray-600 dark:text-gray-300">
            Enter your details to create your account!
          </p>

          {error && <p className="mb-4 text-red-500 text-center">{error}</p>}

          <form onSubmit={handleRegister} className="w-full">
            <InputField
              variant="auth"
              extra="mb-3"
              label="Name*"
              placeholder="Full Name"
              id="name"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <InputField
              variant="auth"
              extra="mb-3"
              label="Email*"
              placeholder="example@gmail.com"
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <InputField
              variant="auth"
              extra="mb-3"
              label="Password*"
              placeholder="••••••••"
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <InputField
              variant="auth"
              extra="mb-3"
              label="Confirm Your Password*"
              placeholder="••••••••"
              id="confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            <div className="mb-3">
              <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                Select Your Timezone*
              </label>
              <select
                id="timezone"
                value={user_timezone}
                onChange={(e) => setTimezone(e.target.value)}
                className="block w-full px-3 py-2 bg-white dark:bg-navy-700 text-gray-700 dark:text-white border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-brand-500 focus:border-brand-500 sm:text-sm"
              >
                {timezones.map((timezone) => (
                  <option key={timezone} value={timezone}>
                    {timezone}
                  </option>
                ))}
              </select>
            </div>

            <InputField
              variant="auth"
              extra="mb-4"
              label="Bot Badge ID"
              placeholder="Eg. S7262-27363-w62221-1"
              id="bot-badge-id"
              type="text"
              value={botBadgeId}
              onChange={(e) => setBotBadgeId(e.target.value)}
            />

            <button
              type="submit"
              className="w-full bg-brand-500 hover:bg-brand-600 active:bg-brand-700 text-white dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200 py-3 rounded-xl text-base font-medium transition duration-200"
            >
              Sign Up
            </button>
          </form>

          <div className="mt-4 text-center">
            <span className="text-sm font-medium text-navy-700 dark:text-gray-400">
              Already have an account?
            </span>
            <Link
              to="/auth/signin"
              className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            >
              Log in.
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Auth;
